import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { defaultItemDisplayStringFunction } from "abreact/incubator/ui/form/AbInputUtils";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbRadioButton } from "abreact/input/AbRadioButton";
import * as AbHooks from "abreact/utils/AbHooks";
import { TypeUtils } from "abweb/utils/TypeUtils";
import * as React from "react";

/**
 * The properties for an AbRadioButtonGroup.
 */

/**
 * A React-based implementation of a radio button group component.
 */
export const AbRadioButtonGroup = props => {
  const groupName = AbHooks.useUniqueId("radio-button-group");
  AbHooks.useAutoSelect(props);
  const renderItem = item => {
    return /*#__PURE__*/React.createElement(AbRadioButton, {
      groupName: groupName,
      key: TypeUtils.itemToKey(item, props.keyFunction),
      value: TypeUtils.equals(props.value, item, props.keyFunction),
      onChange: () => {
        props.onChange(item);
      },
      disabled: props.disabled,
      tabIndex: props.tabIndex,
      label: (props.itemRenderer ?? defaultItemDisplayStringFunction)(item)
    });
  };
  const radioButtonGroupStyle = {
    ...props.style,
    "--ab-radio-button-group-columns-private": props.columns ?? 1
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.inputProps("ab-radio-button-group", props), {
    style: radioButtonGroupStyle,
    tabIndex: undefined
  }), Array.from(props.items, renderItem));
};
//# sourceMappingURL=AbRadioButtonGroup.js.map
